import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import Invoice from "../../model/invoice.model";
import {InvoicePreviewComponent} from "../invoice-preview/invoice-preview.component";
import {ModalData} from "../../types/modal-data.type";

@Component({
    selector: 'app-invoice-modal',
    imports: [
        InvoicePreviewComponent,
    ],
    templateUrl: './invoice-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './invoice-modal.component.scss'
})
export class InvoiceModalComponent {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ModalData) public invoice: Invoice) {}
}
